"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4476],{

/***/ 89345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ en_GB; }
});

// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistance = __webpack_require__(81991);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelative = __webpack_require__(21865);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js
var localize = __webpack_require__(11950);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/match/index.js
var match = __webpack_require__(7219);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
var buildFormatLongFn = __webpack_require__(49526);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-GB/_lib/formatLong/index.js

var dateFormats = {
  full: 'EEEE, d MMMM yyyy',
  long: 'd MMMM yyyy',
  medium: 'd MMM yyyy',
  short: 'dd/MM/yyyy'
};
var timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: (0,buildFormatLongFn/* default */.Z)({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: (0,buildFormatLongFn/* default */.Z)({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0,buildFormatLongFn/* default */.Z)({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-GB/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik]{@link https://github.com/glintik}
 */

var locale = {
  code: 'en-GB',
  formatDistance: formatDistance/* default */.Z,
  formatLong: _lib_formatLong,
  formatRelative: formatRelative/* default */.Z,
  localize: localize/* default */.Z,
  match: match/* default */.Z,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
/* harmony default export */ var en_GB = (locale);

/***/ }),

/***/ 38946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

var SvgCircleCheckmark = function SvgCircleCheckmark(props) {return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({
      height: "16px",
      width: "16px",
      viewBox: "0 0 16 16",
      xmlns: "http://www.w3.org/2000/svg" },
    props), {}, { children: /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1Zm0 13A6 6 0 1 1 8 2a6 6 0 0 1 0 12Zm-1-3.25L4.5 8.27l.795-.785L7 9.175 10.705 5.5l.795.79L7 10.75Z",
        fill: "#000",
        fillRule: "evenodd" }) })));};




/* harmony default export */ __webpack_exports__["Z"] = (SvgCircleCheckmark);

/***/ }),

/***/ 79631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31157);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
var _excluded = ["children"];function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}



var getAppearanceProperties = function getAppearanceProperties(_ref) {var _ref$outline = _ref.outline,outline = _ref$outline === void 0 ? false : _ref$outline,_ref$link = _ref.link,link = _ref$link === void 0 ? false : _ref$link;
  return {
    dark: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["", ""],
    function (_ref2) {var theme = _ref2.theme;
      var color = theme.colors.neutrals.black;
      if (link) {
        return "\n            --color: ".concat(
        color, ";\n            --border: none;\n            --bg-color: transparent;\n            --px: 0px;\n          ");




      } else if (outline) {
        return "\n            --color: ".concat(
        color, ";\n            --border: 1px solid ").concat(
        color, ";\n            --bg-color: transparent;\n          ");


      } else {
        return "\n            --color: #fff;\n            --border: 1px solid ".concat(

        color, ";\n            --bg-color: ").concat(
        color, ";\n          ");

      }
    }),

    blue: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["", ""],
    function (_ref3) {var theme = _ref3.theme;
      var color = theme.colors.primary['blue-1'];
      if (link) {
        return "\n            --color: ".concat(
        color, ";\n            --border: none;\n            --bg-color: transparent;\n            --px: 0px;\n          ");




      } else if (outline) {
        return "\n            --color: ".concat(
        color, ";\n            --border: 1px solid ").concat(
        color, ";\n            --bg-color: transparent;\n          ");


      } else {
        return "\n            --color: #fff;\n            --border: 1px solid ".concat(

        color, ";\n            --bg-color: ").concat(
        color, ";\n          ");

      }
    }),

    'crystal-blue': (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["", ""],
    function (_ref4) {var theme = _ref4.theme;
      var color = theme.colors.primary.crystalBlue;
      if (link) {
        return "\n            --color: ".concat(
        color, ";\n            --border: none;\n            --bg-color: transparent;\n            --px: 0px;\n          ");




      } else if (outline) {
        return "\n            --color: ".concat(
        color, ";\n            --border: 1px solid ").concat(
        color, ";\n            --bg-color: transparent;\n          ");


      } else {
        return "\n            --color: #fff;\n            --border: 1px solid ".concat(

        color, ";\n            --bg-color: ").concat(
        color, ";\n          ");

      }
    }),

    white: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["", ""],
    function (_ref5) {var theme = _ref5.theme;
      var color = theme.colors.neutrals['white'];
      if (link) {
        return "\n            --color: ".concat(
        color, ";\n            --border: none;\n            --bg-color: transparent;\n            --px: 0px;\n          ");




      } else if (outline) {
        return "\n            --color: ".concat(
        color, ";\n            --border: 1px solid ").concat(
        color, ";\n            --bg-color: transparent;\n          ");


      } else {
        return "\n            --color: ".concat(
        theme.colors.neutrals.black, ";\n            --border: 1px solid ").concat(
        color, ";\n            --bg-color: ").concat(
        color, ";\n          ");

      }
    }),

    stone: '' };

};

var getSizeProperties = function getSizeProperties(_ref6) {var rounded = _ref6.rounded;
  return {
    large: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["--font-size:16px;--border-radius:", ";--py:18px;--px:32px;"],

    rounded ? '28px' : '5px'),



    medium: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(["--font-size:13px;--border-radius:", ";--py:12px;--px:24px;"],

    rounded ? '28px' : '5px') };




};




var EL = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(function (_ref7) {var children = _ref7.children,props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref7, _excluded);
  if (props.href) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), _objectSpread(_objectSpread({}, props), {}, { children: children }));
  } else {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", _objectSpread(_objectSpread({}, props), {}, { children: children }));
  }
}).withConfig({ displayName: "ButtonV2__EL", componentId: "sc-1h9zj4y-0" })(["", " ", " display:flex;align-items:center;color:var(--color);font-size:var(--font-size);font-weight:600;text-decoration:none;border:var(--border,none);border-radius:var(--border-radius);padding:var(--py) var(--px);background-color:var(--bg-color);box-shadow:none;cursor:pointer;"],







function (_ref8) {var _ref8$size = _ref8.size,size = _ref8$size === void 0 ? 'medium' : _ref8$size,rounded = _ref8.rounded;return getSizeProperties({ rounded: rounded })[size];},


function (_ref9) {var appearance = _ref9.appearance,link = _ref9.link,outline = _ref9.outline;return (
    getAppearanceProperties({ outline: outline, link: link })[appearance]);});





























var Button = function Button(props) {
  var
  className =









  props.className,_props$appearance = props.appearance,appearance = _props$appearance === void 0 ? 'blue' : _props$appearance,_props$size = props.size,size = _props$size === void 0 ? 'medium' : _props$size,href = props.href,_props$rounded = props.rounded,rounded = _props$rounded === void 0 ? null : _props$rounded,_props$outline = props.outline,outline = _props$outline === void 0 ? null : _props$outline,_props$link = props.link,link = _props$link === void 0 ? null : _props$link,_props$onClick = props.onClick,onClick = _props$onClick === void 0 ? null : _props$onClick,children = props.children,target = props.target;

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(EL, {
      className: className,
      href: href,
      appearance: appearance,
      size: size,
      rounded: rounded,
      link: link,
      outline: outline,
      onClick: onClick,
      target: target, children:

      children }));


};

/***/ }),

/***/ 9128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);

















var MetaTags = function MetaTags(props) {var _props$description, _props$description2;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();

  var thumbnail = "https://devenv.yogobe.com" + '/static/opengraph.png';
  if (props.thumbnailUrl) {var _props$thumbnailUrl, _props$thumbnailUrl2;
    if (
    (_props$thumbnailUrl = props.thumbnailUrl) !== null && _props$thumbnailUrl !== void 0 && _props$thumbnailUrl.startsWith('http') || (_props$thumbnailUrl2 =
    props.thumbnailUrl) !== null && _props$thumbnailUrl2 !== void 0 && _props$thumbnailUrl2.startsWith('//'))
    {
      thumbnail = props.thumbnailUrl;
    } else {
      thumbnail = "https://devenv.yogobe.com" + props.thumbnailUrl;
    }
  }

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("title", { children: props.title + ' - Yogobe' }),
      props.description ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { name: "description", content: props.description }) :
      null, /*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:url", content: "https://devenv.yogobe.com" + router.asPath }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:type", content: "article" }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:title", content: props.title + ' - Yogobe' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:description", content: (_props$description = props.description) !== null && _props$description !== void 0 ? _props$description : '' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:image", content: thumbnail }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "fb:app_id", content: "313516218776996" }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", {
        property: "twitter:title",
        content: "Yoga och tr\xE4ning online f\xF6r h\xE5llbar h\xE4lsa | YOGOBE - Yogobe" }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:title", content: props.title + ' - Yogobe' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:card", content: (_props$description2 = props.description) !== null && _props$description2 !== void 0 ? _props$description2 : '' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:site", content: "https://devenv.yogobe.com" }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:image", content: thumbnail }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:creator", content: "Yogobe" }),
      props.brand && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:brand", content: props.brand }),


      props.availability && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:availability", content: props.availability }),


      props.condition && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:condition", content: props.condition }),


      typeof props.price === 'number' && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:price:amount", content: props.price }),


      props.currency && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:price:currency", content: props.currency }),


      props.retailerId && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:retailer_item_id", content: props.retailerId })] }));



};

/* harmony default export */ __webpack_exports__["Z"] = (MetaTags);

/***/ }),

/***/ 67095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85169);
/* harmony import */ var _components_TextWithIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64370);
/* harmony import */ var _organisms_modals_ConfirmDeletePlaylistModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92913);
/* harmony import */ var _lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47493);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);






var ButtonDeletePlaylist = function ButtonDeletePlaylist(props) {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_3__/* .UserContext */ .S),currentUser = _useContext[0],_useContext$ = _useContext[1],loading = _useContext$.loading,error = _useContext$.error;
  var _useState =


  (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(),confirmDeletePlaylistModalOpen = _useState[0],setConfirmDeletePlaylistModalOpen = _useState[1];

  if (error) return null;

  var DynamicComponent = props.tag;
  if (loading) {
    return /*#__PURE__*/(
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(DynamicComponent, { disabled: loading, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_5__/* .Trans */ .cC, { id: "metadata.please_wait", message: "Please wait..." }) }));


  }

  if ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) !== props.playlist.ownerId) {
    return null;
  }

  if (currentUser !== null && currentUser !== void 0 && currentUser.id) {
    return /*#__PURE__*/(
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(DynamicComponent, {
          onClick: function onClick() {
            setConfirmDeletePlaylistModalOpen(true);
          }, children: /*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_TextWithIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { icon: "ygb-icon-trash", iconSize: "15px", children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_5__/* .Trans */ .cC, { id: "metadata.delete_playlist", message: "Delete Playlist" }) }) }), /*#__PURE__*/


        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_organisms_modals_ConfirmDeletePlaylistModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
          open: confirmDeletePlaylistModalOpen,
          handleClose: function handleClose() {
            setConfirmDeletePlaylistModalOpen(false);
          },
          playlistTitle: props.playlist.title,
          playlistVideoCount: props.playlist.videoCount,
          playlistId: props.playlist.id })] }));



  }

  return null;
};

/* harmony default export */ __webpack_exports__["Z"] = (ButtonDeletePlaylist);

/***/ }),

/***/ 43379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85169);
/* harmony import */ var _components_TextWithIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64370);
/* harmony import */ var _organisms_modals_LoginModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77495);
/* harmony import */ var _organisms_modals_PlaylistModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24331);
/* harmony import */ var _lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47493);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}






var ButtonEditPlaylist = function ButtonEditPlaylist(props) {
  var DynamicComponent = props.tag;
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_5__/* .UserContext */ .S),currentUser = _useContext[0],loading = _useContext[1].loading;

  if (loading) {
    return /*#__PURE__*/(
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(DynamicComponent, _objectSpread(_objectSpread({}, props), {}, { disabled: loading, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_7__/* .Trans */ .cC, { id: "metadata.please_wait", message: "Please wait..." }) })));


  }
  if (currentUser && currentUser.id !== props.playlist.ownerId) {
    return null;
  }
  if (!(currentUser !== null && currentUser !== void 0 && currentUser.id)) {
    return /*#__PURE__*/(
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_organisms_modals_LoginModal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { children:
        function children(handleOpenModal) {return /*#__PURE__*/(
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(DynamicComponent, _objectSpread(_objectSpread({}, props), {}, { onClick: handleOpenModal, children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_7__/* .Trans */ .cC, { id: "metadata.login", message: "Login" }) })));} }));




  } else if (currentUser !== null && currentUser !== void 0 && currentUser.id) {
    return /*#__PURE__*/(
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_organisms_modals_PlaylistModal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { playlist: props.playlist, children:
        function children(handleOpenModal) {return /*#__PURE__*/(
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(DynamicComponent, _objectSpread(_objectSpread({}, props), {}, { onClick: handleOpenModal, children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_TextWithIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { icon: "ygb-icon-edit", iconSize: "15px", children: /*#__PURE__*/
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_7__/* .Trans */ .cC, { id: "metadata.edit_playlist", message: "Edit Playlist" }) }) })));} }));





  }
};

/* harmony default export */ __webpack_exports__["Z"] = (ButtonEditPlaylist);

/***/ }),

/***/ 88460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31157);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var SVG = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].svg.withConfig({ displayName: "ProgressIcon__SVG", componentId: "sc-138o9cm-0" })(["width:18px;height:18px;transform:rotate(180deg);circle{stroke-dashoffset:0;transition:stroke-dashoffset 1s linear;stroke:#ababab;stroke-width:2px;}#bar{stroke:#213E3D;}"]);
















var ProgressIcon = function ProgressIcon(_ref) {var percentage = _ref.percentage;
  var r = 8; // 10 - 2px for stroke
  var c = Math.PI * (r * 2);

  var val = percentage;
  if (val < 0) {
    val = 0;
  } else if (val > 100) {
    val = 100;
  }

  var offset = c - val / 100 * c;

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SVG, { viewBox: "0 0 20 20", version: "1.1", xmlns: "http://www.w3.org/2000/svg", children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
        r: r,
        cx: "10",
        cy: "10",
        fill: "transparent",
        strokeDasharray: "".concat(c, " ").concat(c),
        strokeDashoffset: "0" }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
        id: "bar",
        r: r,
        cx: "10",
        cy: "10",
        fill: "transparent",
        strokeDasharray: "".concat(c, " ").concat(c),
        style: { strokeDashoffset: offset } })] }));



};

/* harmony default export */ __webpack_exports__["Z"] = (ProgressIcon);

/***/ }),

/***/ 92913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71383);
/* harmony import */ var _lingui_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(94471);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12922);
/* harmony import */ var _apollo_client_react_components__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(63659);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85169);
/* harmony import */ var _components_buttons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49613);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94007);
/* harmony import */ var _components_typography_Headings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94268);
/* harmony import */ var _components_typography_Paragraph__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36225);
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10842);
/* harmony import */ var _lib_apollo_policies__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54734);
/* harmony import */ var _lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17516);
/* harmony import */ var _lib_analytics_manager__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88224);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);
var _templateObject;













var DELETE_PLAYLIST = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(["\n  mutation deletePlaylist($id: ID!) {\n    deletePlaylist(id: $id) {\n      status {\n        destroyed\n      }\n    }\n  }\n"])));









var ConfirmDeletePlaylistModal = function ConfirmDeletePlaylistModal(props) {
  var locale = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z);

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(_base__WEBPACK_IMPORTED_MODULE_5__/* .Modal */ .u_, { open: props.open, handleClose: props.handleClose, children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_base__WEBPACK_IMPORTED_MODULE_5__/* .Header */ .h4, { handleClose: props.handleClose, children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { as: _components_typography_Headings__WEBPACK_IMPORTED_MODULE_3__.H4, mt: "0px", mb: "0px", children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_12__/* .Trans */ .cC, {
              id: "confirm_delete_playlist_modal.title",
              message: 'Delete Playlist' }) }) }), /*#__PURE__*/



        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_base__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, { pushFooterDown: 210, children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { mb: 30, children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { as: _components_typography_Paragraph__WEBPACK_IMPORTED_MODULE_4__.P, mt: "0px", mb: "0px", color: "#242424", children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_12__/* .Trans */ .cC, {
                id: "confirm_delete_playlist_modal.description",
                components: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("b", {}, "0")],
                values: {
                  title: props.playlistTitle,
                  videos_count: props.playlistVideoCount } }) }) }) }), /*#__PURE__*/





        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_base__WEBPACK_IMPORTED_MODULE_5__/* .Footer */ .$_, { children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, { flexDirection: "column", flex: 1, children: [/*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { mb: 10, flex: 1, children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_buttons__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                appearance: "default-blue",
                fullWidth: true,
                onClick: props.handleClose, children: /*#__PURE__*/

                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_12__/* .Trans */ .cC, {
                  id: "confirm_delete_playlist_modal.no",
                  message: 'No, keep the playlist' }) }) }), /*#__PURE__*/



            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { flex: 1, children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_apollo_client_react_components__WEBPACK_IMPORTED_MODULE_13__/* .Mutation */ .m, { mutation: DELETE_PLAYLIST, children:
                function children(deletePlaylist) {
                  return /*#__PURE__*/(
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_buttons__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                      fullWidth: true,
                      appearance: "outline",
                      onClick: function onClick() {
                        deletePlaylist({
                          variables: { id: props.playlistId },
                          update: function update(proxy) {
                            delete proxy.data.data[props.playlistId];
                          } }).
                        then(function () {
                          props.handleClose();
                          // I faced this issue https://github.com/zeit/next.js/issues/5947 no solution for it yet
                          window.location.href = "/".concat(locale, "/me/playlists");
                          (0,_lib_apollo_policies__WEBPACK_IMPORTED_MODULE_6__/* .snackbarVar */ .Ck)({
                            isSnackBarOpen: true,
                            goTo: 'NONE',
                            id: 'playlist_delete',
                            snackBarMessage: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_14__/* .i18n._ */ .ag._("playlist.playlist_deleted") });

                          (0,_lib_analytics_manager__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)()._PIXEL_TRACK(
                          'delete-playlist',
                          true,
                          {
                            id: props.playlistId });


                        });
                      }, children: /*#__PURE__*/

                      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_12__/* .Trans */ .cC, {
                        id: "confirm_delete_playlist_modal.yes",
                        message: 'Yes, I want to delete the playlist' }) }));



                } }) })] }) })] }) }));







};

/* harmony default export */ __webpack_exports__["Z"] = (ConfirmDeletePlaylistModal);

/***/ }),

/***/ 30587:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var useMedia_1 = __webpack_require__(88038);
exports.ZP = useMedia_1.default;
__webpack_unused_export__ = useMedia_1.useMedia;
__webpack_unused_export__ = useMedia_1.useMediaLayout;


/***/ }),

/***/ 88038:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __webpack_require__(67294);
var utilities_1 = __webpack_require__(51654);
exports.mockMediaQueryList = {
    media: '',
    matches: false,
    onchange: utilities_1.noop,
    addListener: utilities_1.noop,
    removeListener: utilities_1.noop,
    addEventListener: utilities_1.noop,
    removeEventListener: utilities_1.noop,
    dispatchEvent: function (_) { return true; },
};
var createUseMedia = function (effect) { return function (rawQuery, defaultState) {
    if (defaultState === void 0) { defaultState = false; }
    var _a = react_1.useState(defaultState), state = _a[0], setState = _a[1];
    var query = utilities_1.queryObjectToString(rawQuery);
    effect(function () {
        var mounted = true;
        var mediaQueryList = typeof window === 'undefined'
            ? exports.mockMediaQueryList
            : window.matchMedia(query);
        var onChange = function () {
            if (!mounted) {
                return;
            }
            setState(Boolean(mediaQueryList.matches));
        };
        mediaQueryList.addListener(onChange);
        setState(mediaQueryList.matches);
        return function () {
            mounted = false;
            mediaQueryList.removeListener(onChange);
        };
    }, [query]);
    return state;
}; };
exports.useMedia = createUseMedia(react_1.useEffect);
exports.useMediaLayout = createUseMedia(react_1.useLayoutEffect);
exports["default"] = exports.useMedia;


/***/ }),

/***/ 26426:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
function camelToHyphen(camelString) {
    return camelString
        .replace(/[A-Z]/g, function (string) { return "-" + string.toLowerCase(); })
        .toLowerCase();
}
exports["default"] = camelToHyphen;


/***/ }),

/***/ 51654:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
var camelToHyphen_1 = __webpack_require__(26426);
exports.camelToHyphen = camelToHyphen_1.default;
var queryObjectToString_1 = __webpack_require__(71168);
exports.queryObjectToString = queryObjectToString_1.default;
var noop_1 = __webpack_require__(98419);
exports.noop = noop_1.default;


/***/ }),

/***/ 98419:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
function noop() { }
exports["default"] = noop;


/***/ }),

/***/ 71168:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
var camelToHyphen_1 = __webpack_require__(26426);
var QUERY_COMBINATOR = ' and ';
function queryObjectToString(query) {
    if (typeof query === 'string') {
        return query;
    }
    return Object.entries(query)
        .map(function (_a) {
        var feature = _a[0], value = _a[1];
        var convertedFeature = camelToHyphen_1.default(feature);
        var convertedValue = value;
        if (typeof convertedValue === 'boolean') {
            return convertedValue ? convertedFeature : "not " + convertedFeature;
        }
        if (typeof convertedValue === 'number' &&
            /[height|width]$/.test(convertedFeature)) {
            convertedValue = convertedValue + "px";
        }
        return "(" + convertedFeature + ": " + convertedValue + ")";
    })
        .join(QUERY_COMBINATOR);
}
exports["default"] = queryObjectToString;


/***/ })

}]);